/** 약관 문서의 동의 방식 — isRequired·needsConsent 두 값을 화면에서는 하나로 고른다 */
export type PolicyKind = 'required' | 'optional' | 'notice';

export const POLICY_KIND_OPTIONS: readonly { value: PolicyKind; label: string }[] = [
  { value: 'required', label: '가입 때 필수 동의' },
  { value: 'optional', label: '가입 때 선택 동의' },
  { value: 'notice', label: '게시만 (동의 없음)' },
];

export const POLICY_KIND_LABELS: Record<PolicyKind, string> = {
  required: '가입 시 필수 동의',
  optional: '선택 동의',
  notice: '게시만 · 동의 없음',
};

export function policyKindOf(p: { isRequired: boolean; needsConsent: boolean }): PolicyKind {
  if (!p.needsConsent) return 'notice';
  return p.isRequired ? 'required' : 'optional';
}

export function policyKindFields(kind: PolicyKind): { isRequired: boolean; needsConsent: boolean } {
  return { isRequired: kind === 'required', needsConsent: kind !== 'notice' };
}
